<template>
  <b-modal id="service-clinician-modal-info" hide-footer centered>
    <template v-slot:modal-title> {{ clinician.child.name }}</template>
    <div>
      <form @submit.prevent="saveEmails">
        <div class="d-flex align-items-center mb-2" v-for="(item, index) in emails" :key="index">
          <b-form-input
            v-model="emails[index]"
            placeholder="Enter the email.."
            type="email"
            required
          ></b-form-input>
          <div @click="handleDeleteEmail(index)" class="material-icons icon-delete ml-2 pointer">
            clear
          </div>
        </div>
        <section class="py-2 d-flex justify-content-lg-between">
          <b-button v-if="isValidToAddEmail" variant="primary" @click="addInputEmail"
            >+ Additional Emails</b-button
          >
          <b-button type="submit" class="ml-auto" variant="success">Save</b-button>
        </section>
      </form>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    clinician: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      emails: this.clinician.emails || [],
    };
  },
  beforeMount() {
    this.emails = this.clinician.emails;
  },
  methods: {
    addInputEmail() {
      this.emails.push('');
    },
    openModal() {
      this.emails = this.clinician.emails;
      this.$bvModal.show('service-clinician-modal-info');
    },
    closeModal() {
      this.emails = [];
      this.$bvModal.hide('service-clinician-modal-info');
    },
    saveEmails() {
      this.$emit('updateClinicianReport', { ...this.clinician, emails: this.emails });
      this.closeModal();
    },
    handleDeleteEmail(id) {
      this.emails = this.emails.filter((email, index) => index !== id);
    },
  },
  computed: {
    isValidToAddEmail() {
      return this.emails?.length < 3;
    },
  },
  watch: {
    clinician() {
      this.emails = this.clinician.emails;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-delete {
  color: red;
}
</style>
